import baseAPI from '@/api/base';
import { ToggleEmployeeOffboardingChecklistStatus } from '@/dtos/employee_offboarding_checklist.dto';
import { TOGGLE_EMPLOYEE_OFFBOARDING_CHECKLIST_STATUS_URL } from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeOffboardingChecklist {
  static toggleStatus = async (
    payload: ToggleEmployeeOffboardingChecklistStatus
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_OFFBOARDING_CHECKLIST_STATUS_URL,
      { ...payload }
    );
    return response;
  };
}

export default EmployeeOffboardingChecklist;
